import { render } from "./FireCheck.vue?vue&type=template&id=97b5aba8&scoped=true&ts=true"
import script from "./FireCheck.vue?vue&type=script&lang=ts"
export * from "./FireCheck.vue?vue&type=script&lang=ts"

import "./FireCheck.vue?vue&type=style&index=0&id=97b5aba8&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b5aba8"]])

export default __exports__